import VerificationTableConfig from './VerificationTableConfig';

const columns = (t) => {
  return [
    {
      field: 'companyName',
      label: 'Firma',
      sort: 'desc',
      width: 53,
    },
    ...VerificationTableConfig(t),
  ];
};

export default columns;
